module.exports = __webpack_public_path__ + "static/media/materialStore.1901125c.svg";